import { MediaSection } from './MediaSection'

export default MediaSection
